import type { ButtonHTMLAttributes } from 'react';
import type { LucideIcon } from 'lucide-react';

interface FormatOptionCardProps {
  icon: LucideIcon;
  name: string;
  spec: string;
  range: string;
  selected: boolean;
  disabled?: boolean;
  onSelect: () => void;
  /** Roving-tabindex radio semantics from the parent radiogroup. */
  groupProps?: ButtonHTMLAttributes<HTMLButtonElement>;
}

export function FormatOptionCard({ icon: Icon, name, spec, range, selected, disabled, onSelect, groupProps }: FormatOptionCardProps) {
  return (
    <button
      type="button"
      onClick={onSelect}
      disabled={disabled}
      aria-disabled={disabled}
      className={`flex min-w-0 flex-col gap-2 rounded-lg border p-3 text-left transition-colors disabled:cursor-not-allowed disabled:opacity-40 ${
        selected ? 'border-primary bg-secondary ring-1 ring-primary' : 'border-border bg-card hover:border-primary/30'
      }`}
      {...groupProps}
    >
      <Icon className={`h-5 w-5 ${selected ? 'text-primary' : 'text-muted-foreground'}`} />
      <span className="break-words text-sm font-medium text-foreground">{name}</span>
      <span className="break-words text-xs leading-snug text-muted-foreground">{spec}</span>
      <span className="tnum break-words text-xs leading-snug text-muted-foreground">{range}</span>
    </button>
  );
}
